import { Modal } from '@mantine/core';
import type { FC } from 'react';
import { AuthReferType } from '@/Module/Auth/Component';
import { useDeviceType } from '@/Module/Core/Hook';
import { DeviceType } from '@/Module/Core/Model/Enum';
import { useAppSelector } from '@/Module/Store/Hook';
interface IReferTypeModalProps {
  isOpenRefer: boolean;
}
const ReferTypeModal: FC<IReferTypeModalProps> = ({
  isOpenRefer
}) => {
  const deviceType = useDeviceType();
  const section = useAppSelector(state => state.auth.section);
  const canOpen = section !== 1 && section !== 510 && section !== null;
  return <Modal opened={isOpenRefer && canOpen} size="md" centered onClose={() => {}} overlayProps={{
    className: '',
    style: {
      backdropFilter: '#0e4791'
    },
    backgroundOpacity: 0.35,
    blur: 9
  }} withCloseButton={false} classNames={{
    root: 'bg-[rgba(14, 71, 145, 0.25)] ',
    content: `shadow-theme shadow-blueFive bg-blueOne border-4 border-blueFive px-2 ${deviceType === DeviceType.MOBILE ? 'py-2' : 'py-6'}`
  }} data-sentry-element="Modal" data-sentry-component="ReferTypeModal" data-sentry-source-file="ReferTypeModal.tsx">
      <AuthReferType data-sentry-element="AuthReferType" data-sentry-source-file="ReferTypeModal.tsx" />
    </Modal>;
};
export default ReferTypeModal;